// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__30-th","list":"styles_list__j4jKG"};